import { render } from "./topicSelectionDetail.vue?vue&type=template&id=e174fc2e"
import script from "./topicSelectionDetail.vue?vue&type=script&lang=js"
export * from "./topicSelectionDetail.vue?vue&type=script&lang=js"

import "./topicSelectionDetail.vue?vue&type=style&index=0&id=e174fc2e&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__